import { MemberEntity } from '@/api/member'
import store from '@/store'
import { getModule } from 'vuex-module-decorators'
import authStore from '@/modules/auth/auth.store'
export interface LiveChatSessionVariables {
  memberId: string
  nickName: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  country: string
}

class LiveChatAPI {
  // Setter
  setSessionVariables(payload: LiveChatSessionVariables | null) {
    ;(window as any).LiveChatWidget.call('set_session_variables', payload)
  }

  updateSessionVariables(payload: LiveChatSessionVariables | null) {
    ;(window as any).LiveChatWidget.call('set_session_variables', payload)
  }

  setCustomerName(name: string) {
    ;(window as any).LiveChatWidget.call('set_customer_name', name)
  }

  setCustomerEmail(email: string) {
    ;(window as any).LiveChatWidget.call('set_customer_email', email)
  }

  // Method
  maximize() {
    ;(window as any).LiveChatWidget.call('maximize')
  }

  minimize() {
    ;(window as any).LiveChatWidget.call('minimize')
  }

  hide() {
    ;(window as any).LiveChatWidget.call('hide')
  }

  destroy() {
    try {
      console.log('Destroying livechat')
      ;(window as any).LiveChatWidget.call('destroy')
    } catch {}
  }

  hideGreeting() {
    ;(window as any).LiveChatWidget.call('hide_greeting')
  }

  // setup
  setup() {
    try {
      const authModule = getModule(authStore, store)
      let member = authModule.member
      if (!member) {
        return
      }
      this.setCustomerEmail(member.contactEmail)
      this.setCustomerName(member.nickname)
      this.updateSessionVariables({
        memberId: member.memberId,
        nickName: member.nickname,
        firstName: member.firstName,
        lastName: member.lastName,
        email: member.contactEmail,
        phoneNumber: member.contactPhone,
        country: member.country
      })
      this.minimize()
    } catch {
      // Reset session
      this.setSessionVariables(null)
      this.hide()
    }
  }
}

export default new LiveChatAPI()
